import { render, staticRenderFns } from "./TradingFlowList.vue?vue&type=template&id=31b8fb4d&scoped=true&"
import script from "./TradingFlowList.vue?vue&type=script&lang=js&"
export * from "./TradingFlowList.vue?vue&type=script&lang=js&"
import style0 from "./TradingFlowList.vue?vue&type=style&index=0&id=31b8fb4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b8fb4d",
  null
  
)

export default component.exports